import './styles.scss'

export default function Logo() {
    return (
        <img className="zero-logo" src="logo.svg" alt="ZERO" />
    )
}